export {
  GEE_ALPHAEARTH_COLLECTION,
  GEE_ALPHAEARTH_YEARS,
  GEE_ALPHAEARTH_UI_YEARS,
  GEE_ALPHAEARTH_KNOWN_AVAILABLE_YEARS,
  GEE_ALPHAEARTH_LATEST_KNOWN_AVAILABLE_YEAR,
  GEE_SCENARIO_YEARS,
  clampScenarioYear,
  getDefaultScenarioYear,
} from './map';

export const GEE_DEFAULT_BANDS = ['A01', 'A16', 'A09'] as const;
export const GEE_BAND_RANGE = { min: 0, max: 255 } as const;
